import { environment as baseEnv } from './environment.base';
export const environment = {
  ...baseEnv,
  production: false,
  app_version: 'dev-361',
  api: 'https://api.jargon.dev.epione.net',
  app: 'https://jargon.dev.epione.net',
};
